import { render, staticRenderFns } from "./CustomMask.vue?vue&type=template&id=01927100&scoped=true&"
import script from "./CustomMask.vue?vue&type=script&lang=js&"
export * from "./CustomMask.vue?vue&type=script&lang=js&"
import style0 from "./CustomMask.vue?vue&type=style&index=0&id=01927100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01927100",
  null
  
)

export default component.exports